import { Accordion as AccordionCore } from '@studiometa/ui';
import AccordionItem from './AccordionItem.js';

/**
 *  component
 */
export default class Accordion extends AccordionCore {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Accordion',
    components: {
      AccordionItem,
    },
  };
}
